import { CheckboxField } from '@calendly/ui/form/checkbox-field';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const actionContainerIsPhoneCss = "aamulw9";
const actionContainerIsV4Css = "a1siczq4";
const actionContainerCss = "ah99jez";
const actionItemCss = "akunjq6";
export const ActionContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    v4Styling = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(actionContainerCss, {
    [actionContainerIsPhoneCss]: isPhone && !v4Styling,
    [actionContainerIsV4Css]: v4Styling
  }, props.className)} />;
});
export const ActionItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(actionItemCss, props.className)} />;
});
const daysContainerCss = "d1v9orpm";
export const DaysContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(daysContainerCss, props.className)} />;
});
const dayContainerIsTabletUpCss = "d1yh7f8a";
const dayContainerIsV4Css = "d1d0sv6v";
const dayContainerCss = "dtnm2xb";
export const DayContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    v4Styling = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(dayContainerCss, {
    [dayContainerIsTabletUpCss]: isTabletUp && !v4Styling,
    [dayContainerIsV4Css]: v4Styling
  }, props.className)} />;
});
const dayIconCss = "d3zzxxr";
export const DayIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dayIconCss, props.className)} />;
});
const checkboxIsTabletUpCss = "c1baacu4";
const checkboxIsV4Css = "c17vd51r";
const checkboxCss = "c1d6wk2x";
export const Checkbox = forwardRef((props, ref) => {
  const {
    v4Styling = false,
    ...restProps
  } = props;
  const isTabletUp = useDeviceType('isTabletUp');
  return <CheckboxField ref={ref} {...restProps} className={classNames(checkboxCss, {
    [checkboxIsTabletUpCss]: isTabletUp && !v4Styling,
    [checkboxIsV4Css]: v4Styling
  }, props.className)} />;
});

// Export CSS classes for external usage
export { actionContainerCss, actionItemCss, dayContainerIsV4Css, daysContainerCss, dayContainerCss, dayIconCss, checkboxCss };

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");